import DynamicFormWidget from "../../../widgetsExtend/DynamicFormsV2/widget";
import {WidgetType} from "../../../constants/WidgetConstants";

class AtDynamicFormWidget extends DynamicFormWidget{
  static getWidgetType(): WidgetType {
    return "AT_DYNAMIC_FORM_WIDGET";
  }
}
export default AtDynamicFormWidget;
